import { render } from "./Mini.vue?vue&type=template&id=64a275bb&scoped=true"
import script from "./Mini.vue?vue&type=script&lang=js"
export * from "./Mini.vue?vue&type=script&lang=js"

import "./Mini.vue?vue&type=style&index=0&id=64a275bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a275bb"]])

export default __exports__